import { createClient } from '#src/lib/graphql/client';
import { userStatusInfoQuery } from '#src/lib/user/user-profile-query';

const membershipStatus = (user) =>
  user?.isTrial ? 'trialer' : user?.isWaybetterMember ? 'member' : 'visitor';

const capitalize = (str) => `${str[0].toUpperCase()}${str.slice(1)}`;

export async function getUserStatusInfo() {
  const client = createClient(
    { connectToDevTools: true },
    { initialState: global.__APOLLO_STATE__ }
  );
  const {
    data: { me },
  } = await client.query({ query: userStatusInfoQuery });
  const { gameList, memberships, playerPlans, ...other } = me || {};
  const activeGames = (gameList?.edges || []).map(({ id, title }) => ({
    id,
    title,
  }));

  function objProperties(obj, prefix, filter = () => true) {
    const key = prefix ? (s) => prefix + capitalize(s) : (s) => s;
    return (
      obj &&
      Object.entries(obj)
        .filter(([name]) => filter(name))
        .reduce(
          (x, [name, value]) => ({
            ...x,
            [key(name)]: value,
          }),
          {}
        )
    );
  }

  const currentPlanInfo = objProperties(
    (playerPlans?.edges || []).find((plan) => plan?.phase === 'started'),
    'currentPlan',
    (name) => !name?.startsWith('_')
  );

  return {
    ...other,
    activeGameCount: activeGames.length,
    activeGames,
    ...currentPlanInfo,
    playerPlans: playerPlans?.edges || [],
    memberships: memberships?.edges || [],
    membershipStatus: membershipStatus(me),
  };
}
